// extracted by mini-css-extract-plugin
export default {"root":"AsideSection_root__g7QlX","header":"AsideSection_header__2ZyJO","title":"AsideSection_title__O+4RP utils_line-height-fixed__VfrIp"};